module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-192x192-e3a97080244b77dffbc765e5cf5e0974.png";